var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-nav-wrapper" },
    _vm._l(_vm.mainLinks, function(item) {
      return _c("span", { key: item.order }, [
        _c(
          "a",
          {
            class: { matched: item.order === _vm.activated },
            attrs: { href: item.href, target: "" }
          },
          [_vm._v(_vm._s(item.text))]
        )
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a8f2edea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8f2edea","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav/main-nav.vue
// module id = vUic
// module chunks = 1 2 3 4 5 6 7 8 9